import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { FaqPage } from './pages/FaqPage';
import { FundingPage } from './pages/FundingPage';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
export type Language = 'en' | 'ar';
function RoutedApp() {
  const [language, setLanguage] = useState<Language>('en');
  const location = useLocation();
  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [language, location.pathname]);
  return <Layout language={language} onLanguageChange={setLanguage} data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage language={language} data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage language={language} data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<ServicesPage language={language} data-id="element-7" />} data-id="element-6" />
        <Route path="/funding-partners" element={<FundingPage language={language} data-id="element-9" />} data-id="element-8" />
        <Route path="/faq" element={<FaqPage language={language} data-id="element-11" />} data-id="element-10" />
        <Route path="/contact" element={<ContactPage language={language} data-id="element-13" />} data-id="element-12" />
      </Routes>
    </Layout>;
}
export function App() {
  return <BrowserRouter data-id="element-14">
      <RoutedApp data-id="element-15" />
    </BrowserRouter>;
}